import { isUnauthorizedError } from '@/utils/errors'

export function isWhitelistError(error: any) {
  return isUnauthorizedError(error)
}
